import * as z from 'zod/mini'

/** `GET`/`DELETE event-participations/:eventParticipationId`, the sign-up's own page. */
export const publicEventParticipationParams = z.object({ eventParticipationId: z.uuid() })
export type PublicEventParticipationParams = z.infer<typeof publicEventParticipationParams>

/** `?t=` is the magic-link token from the sign-up's e-mail; without it the page is not shown. */
export const getPublicEventParticipationQuery = z.object({
  t: z.optional(z.string()),
})
export type GetPublicEventParticipationQuery = z.infer<typeof getPublicEventParticipationQuery>
